import { LibraryStoreState, StylovyzeStoreState } from '../types';
import { useSelector } from 'react-redux';

export const useSelectLibraries = (): LibraryStoreState => {
	return useSelector((state: StylovyzeStoreState) => state.library);
};
